import React, { useState } from 'react';
import Category from './category';
import { applyDisplayOrder } from '../helpers/imagecategoryhelper';
import { categoryConstants, categoryLimits } from '../constants/categoryconstants';

const Categories = (props) => {
    const categories = props.images.map(image => {
        return {
            category: image.category,
            imageUrl: image.imageUrl,
            name: image.title
        }
    });
    
    const filtered = applyDisplayOrder(categories.filter(img => {
        return img.category === categoryConstants.CATEGORIES;
    }), window.categoryOrder);
    return (
        <div className="col-md-2 col-sm-2 lurebuilder-categories">
            {filtered.map((category, i) => {
                return <Category category={category} key={i} index={i} handleClick={props.handleClick} selectedCategory={props.selectedCategory} />
            })}
        </div>
    );
}

export default Categories;
